import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { IconContainer, Label, Value, Card, Icon, Cards, Time, EmojiContainer } from './DashboardPage.styles.js';

import openToast from '../../utils/toast.js';

import Car from '../../assets/images/car.png';
import Clock from '../../assets/images/clock.png';
import Logo from '../../assets/icons/logo_purple.svg';

import AppLoader from '../../components/utils/AppLoader.js';

import { selectDashboardDataPending } from '../../store/slices/delivery/slice.js';
import { getDashboardData } from '../../store/slices/delivery/asyncThunks.js';
import { formatTime } from '../../utils/utils.js';
import MainContainer from '../../components/utils/MainContainer/MainContainer.js';

const DashboardPage = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const toastId = useRef(null);

  const loading = useSelector(selectDashboardDataPending);

  const [dashboardInfo, setDashboardInfo] = useState([
    {
      id: 1,
      label: 'deliveries',
      value: 0,
      icon: Car,
      bgColor: 'rgba(236, 195, 113, 0.2)',
    },
    {
      id: 2,
      label: 'sales',
      value: 0,
      icon: '💰',
      bgColor: 'rgba(133, 161, 172, 0.20)',
    },
    {
      id: 3,
      label: 'fees',
      value: 0,
      icon: Logo,
      bgColor: 'rgba(72, 72, 136, 0.20)',
    },
    {
      id: 4,
      label: 'ave-order-ct',
      value: 0,
      icon: Clock,
      bgColor: 'rgba(133, 161, 172, 0.20)',
    },
    {
      id: 5,
      label: 'ave-delivery-ct',
      value: 0,
      icon: Clock,
      bgColor: 'rgba(133, 161, 172, 0.20)',
    },
  ]);

  useEffect(() => {
    dispatch(getDashboardData())
      .unwrap()
      .then(response => {
        setDashboardInfo([
          {
            id: 1,
            label: 'deliveries',
            value: response?.data?.count ?? 0,
            icon: Car,
            bgColor: 'rgba(236, 195, 113, 0.2)',
          },
          {
            id: 2,
            label: 'sales',
            value: response?.data?.totalSales ?? 0,
            icon: '💰',
            bgColor: 'rgba(133, 161, 172, 0.20)',
          },
          {
            id: 3,
            label: 'fees',
            value: response?.data?.totalFees ?? 0,
            icon: Logo,
            bgColor: 'rgba(72, 72, 136, 0.20)',
          },
          {
            id: 4,
            label: 'ave-order-ct',
            value: response?.data?.avg_order_time ?? 0,
            icon: Clock,
            bgColor: 'rgba(133, 161, 172, 0.20)',
          },
          {
            id: 5,
            label: 'ave-delivery-ct',
            value: response?.data?.avg_delivery_time ?? 0,
            icon: Clock,
            bgColor: 'rgba(133, 161, 172, 0.20)',
          },
        ]);
      })
      .catch(err => {
        openToast(toastId, 'login', 'error', t(err.message));
      });
  }, []);

  return (
    <MainContainer pageTitle={'dashboard'}>
      <Cards>
        {dashboardInfo.map(value => (
          <Card key={value.id}>
            <IconContainer style={{ backgroundColor: value.bgColor }}>
              {!value.label.includes('sales') ? (
                <Icon src={value.icon} />
              ) : (
                <EmojiContainer style={{ background: value.bgColor }}>{value.icon}</EmojiContainer>
              )}
            </IconContainer>
            <Label>{t(value.label)}</Label>
            {value.label.includes('ave') ? (
              !loading ? (
                <Time>{formatTime(value.value)}</Time>
              ) : (
                <AppLoader size={32} borderTop={'3px solid #484888'} />
              )
            ) : !loading ? (
              <Value duration={1.5} end={value.value} decimals={value.label === 'fees' || value.label === 'sales' ? 2 : 0} />
            ) : (
              <AppLoader size={32} borderTop={'3px solid #484888'} />
            )}
          </Card>
        ))}
      </Cards>
    </MainContainer>
  );
};

export default DashboardPage;
